import api from "@wallet-manager/node-types/dist/src/access/APIEndpoints/index";
import axios from "./axiosInstance";

const { EPtAssetManagement } = api;

//Contract Sweep Recipient Group
export async function getRecipientGroup(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipientGroup
      .getAll,
    input,
  );
}

export async function getRecipientGroupViewGroup(params: any, config?: any) {
  const input = {
    params,
    ...config,
  };
  return await axios.get(
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipientGroup
      .viewGroup.getAll,
    input,
  );
}

export async function createRecipientGroup(data: any, config?: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipientGroup
      .create;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload, config);
}

export async function editRecipientGroup(data: any, config?: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipientGroup
      .edit;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload, config);
}

export async function deleteRecipientGroup(data: any, config?: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipientGroup
      .delete;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload, config);
}

export async function switchGroup(data: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipientGroup
      .switchGroup;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload);
}

//Contract Sweep Recipient
export async function getRecipient(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipient.getAll,
    input,
  );
}

export async function createRecipient(data: any, config?: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipient
      .viewGroup.create;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload, config);
}

export async function editSweepDestWallet(data: any, config?: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipient
      .viewGroup.edit;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload, config);
}

export async function deleteSweepDestWallet(data: any, config?: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipient
      .viewGroup.delete;
  const payload = {
    ...data,
  };
  return await axios.post(url, payload, config);
}

export async function getRecipientViewGroup(data: any) {
  const url =
    EPtAssetManagement.EndPtAutoSweepDestSetting.contractSweepRecipient
      .viewGroup.getAll;
  const input = {
    params: {
      ...data,
    },
  };
  return await axios.get(url, input);
}
